import request from "@/utils/request"

// 用户列表
export function UserList(pageIndex, pageSize, userName) {
  return request({
    url: "/user/find/all/user",
    method: "POST",
    data: {
      pageIndex,
      pageSize,
      userName
    }
  })
};
// 创建用户
export function CreateUser(userName, tel, userUid, password) {
  return request({
    url: "/user/user/k/create",
    method: "POST",
    data: {
      userName,
      tel,
      userUid,
      password
    }
  })
};
// 删除用户
export function DelUser(id) {
  return request({
    url: `/user/delete/user/${id}`,
    method: "DELETE",
    data: {
      id
    }
  })
};
//查看用户信息
export function UserInfo(id) {
  return request({
    url: `/user/find/user/des/${id}`,
    method: "POST",
    data: {
      id
    }
  })
};
// 修改用户信息
export function upDataUserInfo(id, userName, userUid, password, tel, idCardNumbers, backCardNumber, mail, address) {
  return request({
    url: `/user/user/ids/${id}`,
    method: "PUT",
    data: {
      userName,
      userUid,
      password,
      tel,
      idCardNumbers,
      backCardNumber,
      mail,
      address
    }
  })
}
